import React from "react";
import { Trigger } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useScript } from "~/components/Hooks/useScript";
import Angie from "~/utils/angie.jsx";

const DropboxChooser = ({ appKey, label, onChange, className }) => {
  const dropboxScript = useScript("https://www.dropbox.com/static/api/2/dropins.js");

  const successCallback = (files) => {
    onChange(
      files.map((file) => {
        return {
          ...file,
          code: Angie.functions.random_hash(),
        };
      })
    );
  };

  const openChooser = () => {
    const options = {
      success: successCallback,
      linkType: `preview`,
      multiselect: true,
    };

    // eslint-disable-next-line no-undef
    Dropbox.choose(options);
  };

  return (
    <Trigger
      onClick={openChooser}
      disabled={dropboxScript !== "ready"}
      className={classNames(`dropbox_chooser_button tw-leading-7`, className)}
      id="dropboxjs"
      data-app-key={appKey}
    >
      {label}
    </Trigger>
  );
};

DropboxChooser.propTypes = {
  appKey: PropTypes.string.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
};

DropboxChooser.defaultProps = {
  label: `Dropbox Chooser`,
  onChange: () => null,
};

export default DropboxChooser;
